import gql from 'graphql-tag';

import FlowFields from '~/graphql/fragments/FlowFields';

export default gql`
  mutation UpdateFlow($accountId: ID!, $flow: Flow__Input!) {
    updateFlow(accountId: $accountId, flow: $flow) {
      ...FlowFields
    }
  }

  ${FlowFields}
`;
